<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>企微配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" > 
            <el-collapse accordion style="padding:0px 30px 20px 0px;background-color:#fff;margin-top:-20px;">
                <el-collapse-item>
                    <template slot="title">
                        <div  style="font-size:18px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>配置教程</div>
                    </template>
                    <div style="font-size:14px;color:#333;"> <pre>
  </pre>

                    </div> 
                </el-collapse-item>
            </el-collapse> 
                <span class="label-span">
                    <label class="label">企业名称</label> 
                    <el-input v-model.trim="query.corpName" placeholder="企业名称" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">应用名称</label> 
                    <el-input v-model.trim="query.agentName" placeholder="应用名称" class="handle-input mr10"></el-input> 
                </span> 
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button> 
                <el-button type="primary" icon="el-icon-lx-roundadd" class="mr10"   @click="addBind" >新增应用</el-button> 
                
          </el-card>
          <el-card shadow="hover"  class="containCard" > 
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" width="50" align="left" label="ID"></el-table-column>
                <el-table-column prop="corpName" min-width="190" align="left" label="企业名称"></el-table-column> 
                <el-table-column prop="corpId" min-width="140" align="left" label="企业ID"> </el-table-column> 
                <el-table-column prop="agentName" min-width="80" align="left" label="应用名称"> </el-table-column> 
                <el-table-column prop="agentId" min-width="80" align="left" label="应用ID"> </el-table-column> 
                <el-table-column prop="agentSecret" min-width="200" align="left" label="应用secret"> </el-table-column> 
                <el-table-column prop="channelStatus" min-width="80" align="center" label="应用状态">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status=='1'?'启用':'停用'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column> 
                <el-table-column prop="sure" min-width="80" align="center" label="默认应用">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.sure=='1'?'启用':'停用'" placement="top">
                            <el-switch @change="handleSure(scope.$index, scope.row)"
                                v-model="scope.row.sure"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column> 
                <el-table-column prop="createTime" min-width="160" align="left"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="150" align="center" fixed="right">
                    <template slot-scope="scope">  
                         <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  prev, pager, next" 
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增应用" :modal-append-to-body='false' :visible.sync="addPlusVisible"  width="520px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="企业名称" >
                    <el-input  v-model.trim="form1.corpName" placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="企业ID" >
                    <el-input  v-model.trim="form1.corpId"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用名称" >
                    <el-input  v-model.trim="form1.agentName"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用ID" >
                    <el-input  v-model.trim="form1.agentId"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用secret" >
                    <el-input  v-model.trim="form1.agentSecret"  placeholder="必填"></el-input>   
                </el-form-item>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑应用" :modal-append-to-body='false' :visible.sync="editPlusVisible"  width="520px">
            <el-form ref="form" :model="form3" label-width="90px">
                 <el-form-item label="企业名称" >
                    <el-input  v-model.trim="form3.corpName" placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="企业ID" >
                    <el-input  v-model.trim="form3.corpId"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用名称" >
                    <el-input  v-model.trim="form3.agentName"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用ID" >
                    <el-input  v-model.trim="form3.agentId"  placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="应用secret" >
                    <el-input  v-model.trim="form3.agentSecret"  placeholder="必填"></el-input>   
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
         
 
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,changeSure} from '../../api/wxWork';  
export default {

    data() {
        return {  
            Timeout:'',
            mid:'', 
            secret:'',
            stationId:'', 
            loginName:'',
            activeNames:1,
            select:{ option:'',  }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                payType:'2',
                useType:'1', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
        this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'corpName', '');  
            this.$set(this.query, 'agentName');   
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){   
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        
        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {   
            if( !this.form1.corpName ){
                this.$message.error("请填写企业名称");
                return;
            }
            if( !this.form1.corpId ){
                this.$message.error("请填写企业ID");
                return;
            } 
            if( !this.form1.agentName ){
                this.$message.error("请填写应用名称");
                return;
            } 
            if( !this.form1.agentId ){
                this.$message.error("请填写应用ID");
                return;
            }  
            if( !this.form1.agentSecret ){
                this.$message.error("请填写应用secret");
                return;
            }   
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.addVisible = false;
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {   
            if( !this.form3.corpName ){
                this.$message.error("请填写企业名称");
                return;
            }
            if( !this.form3.corpId ){
                this.$message.error("请填写企业ID");
                return;
            } 
            if( !this.form3.agentName ){
                this.$message.error("请填写应用名称");
                return;
            } 
            if( !this.form3.agentId ){
                this.$message.error("请填写应用ID");
                return;
            }  
            if( !this.form3.agentSecret ){
                this.$message.error("请填写应用secret");
                return;
            }   
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            changeStatus(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.status=='1'){
                        row.status = '0';
                    }else{
                        row.status = '1';
                    } 
                } 
            }); 
        },
        // q启用、禁用--改变状态
        handleSure(index, row) {  
            changeSure(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.sure=='1'){
                        row.sure = '0';
                    }else{
                        row.sure = '1';
                    } 
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去顶要删除该商户吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
